import React, { useState } from 'react';
import { Button, Form, Input, Space, Spin, message } from 'antd';
import get from 'lodash/get';
import assign from 'lodash/assign';
import map from 'lodash/map';
import { useSelector, useDispatch } from 'react-redux';
import { USER_UPDATE_SUCCESS } from '../../constants/messages';
import { userMangement } from '../../redux/actions/authActions';

function UserDetailForm(props) {
  const { refreshUser, isSuperAdmin } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const user = useSelector((state) => get(state, 'auth.user', null));
  const isDisabled = isSuperAdmin;
  const onFinish = (values) => {
    const paylaod = {};
    map(values, (v, k) => {
      if (v) {
        assign(paylaod, {
          [k]: v,
        });
      }
    });
    setLoading(true);

    dispatch(userMangement('update.me', paylaod))
      .then(() => {
        message.success(USER_UPDATE_SUCCESS);
        form.setFieldsValue({ password: undefined });
        refreshUser();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className="user-detail-form-container">
      <Spin spinning={loading}>
        <Form
          name="basic"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          initialValues={{
            name: get(user, 'name'),
            email: get(user, 'email'),
            mobile: get(user, 'mobile'),
          }}
        >
          <div className="mt-20">
            <Form.Item
              label="Full Name"
              name="name"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please input your name!',
                },
              ]}
            >
              <Input
                disabled={isDisabled}
                size="large"
                placeholder="Enter Email or mobile no."
              />
            </Form.Item>
          </div>
          <div className="mt-20">
            <Form.Item
              label="Email-Id "
              name="email"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please input your registered email!',
                },
                {
                  type: 'email',
                  message: 'Please Input valid email',
                },
              ]}
            >
              <Input
                disabled={isDisabled}
                size="large"
                placeholder="Enter Email or mobile no."
              />
            </Form.Item>
          </div>
          <div className="mt-20">
            <Form.Item
              label="Contact No"
              name="mobile"
              className="form-item"
              rules={[
                {
                  required: true,
                  message: 'Please input your contact number!',
                },
              ]}
            >
              <Input
                disabled={isDisabled}
                size="large"
                placeholder="+91123456789"
              />
            </Form.Item>
          </div>
          {!isDisabled && (
            <div className="mt-40">
              <Form.Item label="Password" name="password">
                <Input.Password
                  size="large"
                  placeholder="Enter your password"
                />
              </Form.Item>
            </div>
          )}
          {!isDisabled && (
            <div className="mt-40">
              <Space size="large">
                <Button type="primary" htmlType="submit" className="login-btn">
                  Save & Next
                </Button>
                <Button className="login-btn">Cancel</Button>
              </Space>
            </div>
          )}
        </Form>
      </Spin>
    </div>
  );
}

export default UserDetailForm;
